import styled from '@emotion/styled';

export const StyledDrawingPanel = styled.div<{ isPen: boolean; cursor: string; isAccessible: boolean }>`
  position: absolute !important;
  z-index: ${({ isPen }) => (isPen ? 45 : 40)};
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: ${({ isPen }) => (isPen ? 'initial' : 'none')};
  cursor:
    url(${({ cursor }) => cursor}) 1 23,
    pointer;

  ${({ isAccessible }) =>
    !isAccessible &&
    `
  opacity: 0.1;
  pointer-events: none;
  `}
`;
